import { Card, Typography } from 'src/components/common';
import { Form, Formik } from 'formik';
import { PersonIcon, MailIcon } from 'src/components/common/common.icons';
import InputField from 'src/components/common/formFields/inputField/InputField';
import { colors, componentSizeVariantsEnum } from 'src/constants';
import Button from 'src/components/button/Button';
import { Col, Row, Dropdown } from 'react-bootstrap';
import { useGetIdentity } from 'src/hooks';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { openPopup } from 'src/store/common/common.slice';
import { StorageUtils } from 'src/utils';

import './applicantDetails.scss';
import applicantDetailsValidationSchema from './applicantDetails.validationSchema';
import { TApplicantDetailsProps, TApplicationDetailsFormValues } from './applicantDetails.types';
import { useEffect } from 'react';
import SelectCardRadio, {
  TSelectCardRadioButton
} from 'src/components/common/formFields/selectCardRadio/SelectCardRadio';
import Label from 'src/components/common/formFields/label/Label';

const ApplicantDetails = ({ updateApplicantDetails, applicantDetails }: TApplicantDetailsProps) => {
  const loggedInUser: any = StorageUtils.get('loggedInUser');

  const initialValues: TApplicationDetailsFormValues = {
    name: loggedInUser?.name || '',
    email: loggedInUser?.email || '',
    mobile: applicantDetails?.mobile?.toString() || ''
    // userType: ''
  };

  // Hooks
  const { getIdentities } = useGetIdentity();
  const dispatch = useAppDispatch();
  const { myCompany } = useAppSelector((store) => store.company);

  // Constants
  const { loggedInUserType } = getIdentities();

  const handleSubmit = (values: TApplicationDetailsFormValues) => {
    console.log(values, 'values');
    if (loggedInUserType === 'Company') {
      dispatch(
        openPopup({
          popupMessage: `You cannot apply to this program because you are an ${myCompany?.type}`,
          popupType: 'error'
        })
      );
    } else {
      updateApplicantDetails(values);
    }
  };

  return (
    <Card className="apply-program-applicant-details">
      <Typography
        as="p"
        variant="body-1"
        fontWeight="semiBold"
        style={{ color: colors.neutral[1000] }}
      >
        Application Form
      </Typography>
      <Typography
        as="p"
        variant="caption"
        fontWeight="regular"
        style={{ color: colors.neutral[1000] }}
      >
        To apply for this program, please fill out the application form below. Make sure all fields
        are filled in correctly.
      </Typography>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={applicantDetailsValidationSchema}
        enableReinitialize={true} // Allows Formik to reinitialize with new values
      >
        {({ values, setFieldValue }) => {
          useEffect(() => {
            if (applicantDetails?.mobile) {
              setFieldValue('mobile', applicantDetails.mobile.toString());
            }
          }, [applicantDetails, setFieldValue]);

          return (
            <Form className="apply-program-applicant-details__form" noValidate>
              <InputField
                label="Full Name"
                id="name"
                variant={componentSizeVariantsEnum.SMALL}
                placeholder="Full Name"
                startIcon={<PersonIcon />}
                type="text"
                required
                disabled
              />
              <InputField
                label="Email"
                id="email"
                variant={componentSizeVariantsEnum.SMALL}
                placeholder="Email Address"
                startIcon={<MailIcon />}
                type="email"
                required
                disabled
              />
              <InputField
                label="Mobile"
                id="mobile"
                variant={componentSizeVariantsEnum.SMALL}
                placeholder="Phone number"
                type="number"
                required
              />
              {/* <Dropdown>
                <Dropdown.Toggle id="dropdown-basic-6">who are you</Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    href="#"
                    onClick={() => setFieldValue('mobile', applicantDetails.mobile.toString()) }
                  >
                    <p>
                      <span>Add Services</span>
                    </p>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown> */}
              <Button variant="primary" size="small" type="submit">
                Continue
              </Button>
            </Form>
          );
        }}
      </Formik>
    </Card>
  );
};

export default ApplicantDetails;
